<template>
  <div>
    <v-card class="sf-card"
            flat>
      <div class="sf-card__header">
        <h2 class="sf-card__title">{{ $t('settings') }}</h2>
      </div>
      <v-card-text class="sf-card__body">
        <v-form ref="form">
          <v-text-field dense class="mb-4"
                        hide-details="auto"
                        outlined
                        v-bind:label="$t('name')"
                        v-bind:rules="[ rules.required ]"
                        v-model="customEmailTemplate.name" />
          <v-text-field dense class="mb-4"
                        hide-details="auto"
                        outlined
                        v-bind:hint="$t('titleHint')"
                        persistent-hint
                        v-bind:label="$t('title')"
                        v-bind:rules="[ rules.required ]"
                        v-model="customEmailTemplate.title" />
          <v-text-field dense class="mb-4"
                        hide-details="auto"
                        outlined
                        v-bind:hint="$t('preheaderHint')"
                        persistent-hint
                        v-bind:label="$t('preheader')"
                        v-model="customEmailTemplate.preheader" />
          <v-row class="sf-form-row">
            <v-col cols="12"
                   md="6">
              <v-select dense hide-details="auto"
                        outlined
                        v-bind:disabled="editMode"
                        v-bind:items="audiences"
                        v-bind:label="$t('audience')"
                        v-bind:rules="[ rules.required ]"
                        v-model="customEmailTemplate.audience" />
            </v-col>
            <v-col cols="12"
                   md="6">
              <v-select dense hide-details="auto"
                        outlined
                        v-bind:hint="$t('kindHint')"
                        persistent-hint
                        v-bind:items="kinds"
                        v-bind:label="$t('kind')"
                        v-model="customEmailTemplate.kind" />
            </v-col>
          </v-row>

          <template v-if="customEmailTemplate.kind !== 'Layout'">
            <h3 class="sf-section-title mt-6">{{ $t('flowControl') }}</h3>
            <v-row class="sf-form-row">
              <v-col cols="12"
                     md="6">
                <v-select dense clearable
                          hide-details="auto"
                          outlined
                          v-bind:items="states"
                          v-bind:label="$t('onlyIfState')"
                          v-model="customEmailTemplate.onlyIfState" />
              </v-col>
              <v-col cols="12"
                     md="6">
                <v-select dense clearable
                          hide-details="auto"
                          outlined
                          v-bind:items="states"
                          v-bind:label="$t('changeToState')"
                          v-model="customEmailTemplate.changeToState" />
              </v-col>
            </v-row>
          </template>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
  export default {
    computed: {
      audiences() {
        return [
          { text: this.$t('customers'), value: 'Customer' },
          { text: this.$t('suppliers'), value: 'Supplier' }
        ]
      },
      kinds() {
        return [
          { text: this.$t('kindEmail'), value: 'Email' },
          { text: this.$t('kindLayout'), value: 'Layout' }
        ]
      },
      states() {
        return [
          { text: this.$t('open'), value: 'open' },
          { text: this.$t('invited'), value: 'invited' },
          { text: this.$t('accepted'), value: 'accepted' },
          { text: this.$t('declined'), value: 'declined' }
        ]
      },
      rules() {
        return {
          required: v => !!v || this.$t('form.required')
        }
      }
    },
    methods: {
      validate() {
        return this.$refs.form.validate()
      }
    },
    name: 'CustomEmailTemplateEditCard',
    props: {
      customEmailTemplate: Object,
      editMode: Boolean
    }
  }
</script>

<i18n>
  {
    "de": {
      "settings": "Einstellungen",
      "name": "Name (intern)",
      "title": "Betreff",
      "titleHint": "Platzhalter wie {'{{'}fairName{'}}'} sind auch im Betreff möglich.",
      "preheader": "Vorschautext",
      "preheaderHint": "Wird in der Posteingangsliste neben dem Betreff angezeigt.",
      "audience": "Zielgruppe",
      "customers": "Kunden",
      "suppliers": "Lieferanten",
      "kind": "Art",
      "kindEmail": "E-Mail",
      "kindLayout": "Layout (Startvorlage)",
      "kindHint": "Layouts dienen als Ausgangspunkt für neue E-Mails und werden nicht versendet.",
      "flowControl": "Flow-Steuerung",
      "onlyIfState": "Nur senden, wenn Status",
      "changeToState": "Nach dem Senden Status ändern zu",
      "open": "Offen",
      "invited": "Eingeladen",
      "accepted": "Angenommen",
      "declined": "Abgelehnt"
    },
    "en": {
      "settings": "Settings",
      "name": "Name (internal)",
      "title": "Subject",
      "titleHint": "Placeholders such as {'{{'}fairName{'}}'} also work in the subject.",
      "preheader": "Preview text",
      "preheaderHint": "Shown next to the subject in the inbox list.",
      "audience": "Audience",
      "customers": "Customers",
      "suppliers": "Suppliers",
      "kind": "Kind",
      "kindEmail": "Email",
      "kindLayout": "Layout (starting template)",
      "kindHint": "Layouts are starting points for new emails and are never sent.",
      "flowControl": "Flow control",
      "onlyIfState": "Only send if state",
      "changeToState": "After sending change state to",
      "open": "Open",
      "invited": "Invited",
      "accepted": "Accepted",
      "declined": "Declined"
    }
  }
</i18n>
